import { ConfigStateContext } from "../../../../shared-components/Contexts/Configurations/context";
import { PricingCardProps } from "../../../../shared-components/Components/Pricing/PricingCards/PricingCard/web";
import { useContext } from "react";
import { postRequest } from "@Utils/Functions";
import { Button } from "antd";
import { RightOutlined } from "@ant-design/icons";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

export const usePublishTemporal = () => {
	const { country_code } = useContext(ConfigStateContext);
	const screen = useBreakpoint();

	const selectPlan = () => {
		postRequest("https://www.infocasas.com.uy/?mid=propiedades&func=ajax_seleccion_aviso", {
			IDconcepto: 21,
			from: "landing.temporales",
		});

		window.open(
			"https://www.infocasas.com.uy/sitio/index.php?mid=propiedades&func=add&store&op=4"
		);
	};

	const UY_TEMPORAL_PRICING: PricingCardProps[] = [
		{
			title: "Plan Clásico",
			price: 80,
			currency: "USD",
			bullets: [
				"Tu aviso en Casas en el Este con alcance internacional",
				"Tu aviso en InfoCasas con 80% de descuento",
				"Nuevos filtros: tu casa más fácil de encontrar!",
				"Subí hasta 15 fotos",
				"Asesoramiento y tips para alquilar mejor",
				"Atención telefónica",
			],
			callToAction: "Continuar",
			action: selectPlan,
		},
		{
			title: "Plan Baja temporada",
			price: 125,
			currency: "USD",
			bullets: [
				"Publicación Gratis en InfoCasas, el portal inmobiliario número 1 de Uruguay",
				"5 veces más oportunidades de alquiler en temporada baja",
				"Rotación en nuestro newsletter de propiedades destacadas",
				"Tu aviso entre los recomendados de Casas en el Este",
				"Publicidad en nuestro Facebook",
				"32 Fotos + Video",
			],
			callToAction: "Continuar",
			action: selectPlan,
		},
		{
			title: "Plan Pro",
			price: 125,
			currency: "USD",
			bullets: [
				"Mejor posicionamiento en los resultados de búsqueda",
				"Preferencia en nuestros recomendados para los usuarios",
				"Identidad Verificada",
				"Publicidad en nuestro Facebook",
				"32 Fotos + Video",
			],
			callToAction: "Continuar",
			action: selectPlan,
		},
		{
			title: "Plan Full",
			price: 150,
			currency: "USD",
			highlight: "Destacado",
			bullets: [
				"Mejor posicionamiento en los resultados de búsqueda",
				"Preferencia en nuestros recomendados para los usuarios",
				"Tu aviso entre los recomendados de Casas en el Este",
				"5 veces más oportunidades de alquiler en temporada baja",
				"Identidad Verificada",
				"Publicidad en nuestro Facebook",
				"32 Fotos + Video",
			],
			callToAction: "Continuar",
			action: selectPlan,
		},
	];

	// table data
	const rowItems = {
		name: "",
		price: "Precio (USD)",
		duration: "Duración (Años)",
		photos: "Fotos",
		videos: "Videos",
		scope: "Alcance Internacional",
		limited: "Edición Limitada",
		phone_atention: "Atención Telefónica",
		advicement: "Asesoramiento",
		fb_advert: "Promoción en Facebook",
		google_advert: "Promoción en Google",
		offers: "Promoción de Ofertas",
		internacional_advert: "Promoción Internacional",
		advert_design: "Diseño de Avisos",
		highlight: "Destaque",
		verification: "Identidad Verificada",
		special_filter: "Filtros Especiales",
		continue: "",
	};

	const planes = [
		{
			name: "Clásico",
			duration: 1,
			price: 80,
			photos: 15,
			videos: false,
			scope: true,
			limited: true,
			phone_atention: true,
			advicement: true,
			fb_advert: false,
			google_advert: false,
			offers: false,
			internacional_advert: false,
			advert_design: false,
			highlight: false,
			verification: false,
			special_filter: false,
			continue: (
				<Button type="primary" className="continue-button" onClick={selectPlan} block>
					{screen.xs ? <RightOutlined /> : "Continuar"}
				</Button>
			),
		},
		{
			name: "Baja Temporada",
			duration: 1,
			price: 125,
			photos: 32,
			videos: true,
			scope: true,
			limited: true,
			phone_atention: true,
			advicement: true,
			fb_advert: true,
			google_advert: true,
			offers: true,
			internacional_advert: false,
			advert_design: false,
			highlight: false,
			verification: false,
			special_filter: true,
			continue: (
				<Button type="primary" className="continue-button" onClick={selectPlan} block>
					{screen.xs ? <RightOutlined /> : "Continuar"}
				</Button>
			),
		},
		{
			name: "Pro",
			duration: 1,
			price: 125,
			photos: 32,
			videos: true,
			scope: true,
			limited: true,
			phone_atention: true,
			advicement: true,
			fb_advert: false,
			google_advert: false,
			offers: false,
			internacional_advert: true,
			advert_design: true,
			highlight: true,
			verification: true,
			special_filter: true,
			continue: (
				<Button type="primary" className="continue-button" onClick={selectPlan} block>
					{screen.xs ? <RightOutlined /> : "Continuar"}
				</Button>
			),
		},
		{
			name: "Full",
			duration: 1,
			price: 150,
			photos: 32,
			videos: true,
			scope: true,
			limited: true,
			phone_atention: true,
			advicement: true,
			fb_advert: true,
			google_advert: true,
			offers: true,
			internacional_advert: true,
			advert_design: true,
			highlight: true,
			verification: true,
			special_filter: true,
			continue: (
				<Button type="primary" className="continue-button" onClick={selectPlan} block>
					{screen.xs ? <RightOutlined /> : "Continuar"}
				</Button>
			),
		},
	];

	return {
		cards: country_code == "UY" ? UY_TEMPORAL_PRICING : [],
		table:
			country_code == "UY"
				? {
						rowsItems: rowItems,
						data: planes,
				  }
				: null,
	};
};
